// extracted by css-extract-rspack-plugin
export default {"orderInfoRow":"orderInfoRow-s2MOXJ"};